const stripHTML = (html) => {
  const one = html.replace(/<\/?[^>]+(>|$)/gm, '')
  const two = one.replace(/[\r\n]\s*[\r\n]/gm, '')
  return two
}

const makeProdSchema = (prod) => {
  const desc = stripHTML(prod.description)
  return {
      // schema truncated for brevity
      '@context': 'http://schema.org',
      '@type': 'Product',
      description: desc,
      name: prod.name,
      image: prod.image,
      'aggregateRating': {
        '@type': 'AggregateRating',
        'ratingValue': prod.ratingValue,
        'ratingCount': prod.ratingCount,
        'worstRating': '1',
        'bestRating': '5'
      }
  }
}

export  function getProductSchemes(prod ) {
  return (
    <script
      key={`prodJSON-${prod.id}`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(makeProdSchema(prod)) }}
    />
  )
}
